import { render } from "./AccessEditUserSettings.vue?vue&type=template&id=46b6c59a"
import script from "./AccessEditUserSettings.vue?vue&type=script&lang=js"
export * from "./AccessEditUserSettings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__